.sql_field_height_140 {
  height: 140px;
}

.sql_field_width_full {
  width: 100%;
}
